import { chain } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastSuccess } from '@components/Toast';

import AddNewTaskModal from '@features/order/components/TNA/AddNewTaskModal';
import CreateDuplicateTNA from '@features/order/components/TNA/CreateDuplicateTNA';
import EtdDetails from '@features/order/components/TNA/EtdDetails';
import SetProductsTabButtons from '@features/order/components/TNA/SetProductsTabButtons';
import TnaStylesList from '@features/order/components/TNA/TnaStylesList';
import TNAAccordian from '@features/order/components/TNA/TNAAccordian';
import {
	CREATE_TASK_MODAL_REQUIRED_FIELDS,
	GROUP_BY_TASK_LIST,
	INITIAL_TASK_MODAL_STATE,
	isPlaningPending,
	isProductOfSet,
	isSetProduct,
	PLANNING_STATUS,
	SUB_TASK_LABEL,
	TNA_REQUEST_TYPE
} from '@features/order/utils/projectUtil';

import tnaService from '@services/tna-service';

import { generateRandomString, printApiError, STATIC_SET_CONSTANTS, validateNumber } from '@utils/Util';

const CreateTna = ({
	orderId,
	isShowProducts = true,
	planningStatus,
	rfqId,
	callback,
	getProductList,
	requestFrom,
	tnaRunningStyleStatus,
	selectedStyleDetailsFromRunning,
	runningProductList,
	setProductList
}) => {
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [tnaProductList, setTnaProductList] = useState([]);
	const [tnaTemplateDays, setTnaTemplateDays] = useState([]);
	const [selectedRfqId, setSelectedRfqId] = useState(0);
	const [selectedStyle, setSelectedStyle] = useState(null);
	const [selectedTemplateDays, setSelectedTemplateDays] = useState(null);
	const [stageTaskList, setStageTaskList] = useState([]);
	const [taskFormInputData, setTaskFormInputData] = useState(INITIAL_TASK_MODAL_STATE);
	const [serialList, setSerialList] = useState([]);
	const navigate = useNavigate();
	const [activeSetMemberId, setActiveSetMemberId] = useState(null);
	const [productsOfSet, setProductsOfSet] = useState([]);
	const [isFinishTabVisible, setIsFinishTabVisible] = useState(false);
	const [isTnaHasSetProduct, setIsTnaHasSetProduct] = useState(false);
	const [submittedSetMembers, setSubmittedSetMembers] = useState([]);
	const [selectedProductId, setSelectedProductId] = useState(null);
	const [errors, setErrors] = useState({});
	const [seletecdCellForDuration, setSeletecdCellForDuration] = useState('');
	const [changedDuration, setChangedDuration] = useState(null);
	const [selectedStyleDetails, setSelectedStyleDetails] = useState(null);
	const [isSelecteButtonClicked, setIsSelectedButtonClicked] = useState(false);
	const [isUsingExcel, setIsUsingExcel] = useState(false);
	const [isCompleated, setIsCompleated] = useState(false);
	const [listOfAllTnaProduct, setListOfAllTnaProduct] = useState([]);
	const [rfqStatusInfoList, setRfqStatusInfoList] = useState([]);
	const [selectedETD, setSelectedETD] = useState(0);
	const [selectedProduct, setSelectedProduct] = useState(null);
	//const [selectedIndex, setSelectedIndex] = useState(0);

	useEffect(() => {
		//set listOfAllTnaProduct[0].rfqStatusInfoList to setRfqStatusInfoList
		if (listOfAllTnaProduct.length > 0) {
			setRfqStatusInfoList(listOfAllTnaProduct[0].rfqStatusInfoList);
		}
	}, [listOfAllTnaProduct]);
	useEffect(() => {
		//set listOfAllTnaProduct[0].rfqStatusInfoList to setRfqStatusInfoList
		if (listOfAllTnaProduct.length > 0) {
			setSelectedProduct(listOfAllTnaProduct[0]);
		}
	}, [listOfAllTnaProduct]);

	useEffect(() => {
		setListOfAllTnaProduct(tnaProductList);
	}, [JSON.stringify(tnaProductList)]);

	useEffect(() => {
		if (selectedStyleDetailsFromRunning) {
			setSelectedStyleDetails(selectedStyleDetailsFromRunning);
		}
	}, [selectedStyleDetailsFromRunning?.rfqId]);

	const handleTnaSelection = (product, requestType) => {
		if (isProductOfSet(product) && product.setMemberList && product.setMemberList.length > 0) {
			const firstSetMemberRfqId = product?.setMemberList[0]?.id;
			getSelectedTna(product?.rfqId, '', firstSetMemberRfqId, requestType || product?.planningSource);
		} else {
			getSelectedTna(product?.rfqId, '', '', requestType || product?.planningSource);
		}
	};

	// Fetch all the TNA product list and add default slected product (*styles list)
	const getAllProductList = async (shouldSelect = true) => {
		const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);
		setTnaProductList(tnaProductListResponse);

		let initialSelectedProduct = tnaProductListResponse.find(
			(product) => product?.planningStatus === PLANNING_STATUS.PENDING
		);
		if (shouldSelect) {
			if (initialSelectedProduct) {
				handleTnaSelection(initialSelectedProduct);
			} else {
				handleTnaSelection(tnaProductListResponse[0]);
			}
		}
	};

	const getSelectedTna = async (rfqId, templateName = '', idOfSetMember, planningSource) => {
		try {
			setLoading(true);
			const selectedTnaResponse = await tnaService.selectedTna(
				orderId,
				rfqId,
				templateName,
				idOfSetMember,
				planningSource
			);
			setSelectedRfqId(rfqId);
			setSelectedStyle(selectedTnaResponse);
		} catch (error) {
			printApiError(error);
		} finally {
			setLoading(false);
		}
	};

	const getTemplateDays = async () => {
		try {
			const templateDays = await tnaService.getTemplateDays();
			setTnaTemplateDays(templateDays);
		} catch {
			/* empty */
		}
	};

	const isExcelFileSubmitted = () => {
		return (
			selectedStyle?.planningSource === TNA_REQUEST_TYPE.EXCEL_FILE &&
			isCompleated &&
			selectedStyle?.rfqId === selectedStyleDetails?.rfqId
		);
	};

	useEffect(() => {
		if (selectedStyle?.planningSource === TNA_REQUEST_TYPE.EXCEL_FILE) {
			setIsUsingExcel(true);
			setSelectedTemplateDays(null);
		} else {
			setIsUsingExcel(false);
			setSelectedTemplateDays({
				templateDurationDays: selectedStyle?.timeOfCompletion,
				templateName: selectedStyle?.templateName
			});
		}
		if (
			selectedStyle?.status === PLANNING_STATUS.COMPLETED ||
			selectedStyle?.status === PLANNING_STATUS.SUBMITTED
		) {
			setIsCompleated(true);
		} else {
			setIsCompleated(false);
		}
	}, [selectedStyle]);

	useEffect(() => {
		setLoading(true);
		getTemplateDays();
		if (requestFrom !== 'TNA_RUNNING') getAllProductList();
		setLoading(false);
	}, [requestFrom]);

	useEffect(() => {
		if (
			planningStatus === PLANNING_STATUS.PENDING ||
			(planningStatus === PLANNING_STATUS.SUBMITTED && rfqId && requestFrom === 'TNA_RUNNING')
		) {
			onSelectProduct(selectedStyleDetailsFromRunning, rfqId);
		}
	}, [rfqId, requestFrom]);

	const getInitialSetProduct = () => {
		if (
			(tnaProductList?.length > 0 && selectedRfqId) ||
			(runningProductList?.length > 0 && selectedStyleDetailsFromRunning?.rfqId)
		) {
			const productList = requestFrom === 'TNA_RUNNING' ? runningProductList : tnaProductList;

			const isRequestFromRunning = (product) => {
				if (requestFrom === 'TNA_RUNNING') {
					return selectedStyleDetailsFromRunning?.rfqId === product?.rfqId;
				} else {
					return product?.rfqId === selectedRfqId;
				}
			};

			const selectedSetProduct = productList.find(
				(product) => isRequestFromRunning(product) && isProductOfSet(product)
			);

			if (selectedSetProduct) {
				extractAndOrganizeSetMembers([selectedSetProduct]);
				setIsTnaHasSetProduct(true);
			} else {
				extractAndOrganizeSetMembers([]);
				setActiveSetMemberId(null);
				setIsTnaHasSetProduct(false);
			}
		}
	};

	useEffect(() => {
		getInitialSetProduct();
	}, [selectedRfqId, tnaProductList, selectedStyleDetailsFromRunning?.rfqId, runningProductList]);

	const generateSerial = () => {
		let sl = 0;
		let taskList = [];
		if (selectedStyle?.taskPlanningResponseList) {
			chain(selectedStyle?.taskPlanningResponseList)
				.groupBy(GROUP_BY_TASK_LIST)
				.map((value, key) => ({
					[GROUP_BY_TASK_LIST]: key,
					[SUB_TASK_LABEL]: value
				}))
				.value()
				.map((task) => {
					return task.subTask.map((subTask) => {
						sl = sl + 1;
						taskList.push({
							serial: sl,
							stepDescription: subTask.stepDescription
						});
					});
				});
		}
		setSerialList(taskList);
	};

	useEffect(() => {
		generateSerial();
	}, [selectedStyle]);

	const isEveryProductOfSetSubmitted = () => {
		let selectedItem = tnaProductList?.find(
			(item) => item.rfqId === selectedRfqId || item?.rfqId === selectedStyleDetailsFromRunning?.rfqId
		);
		let tmpIsEveryMemberSubmitted = false;
		if (selectedItem && isProductOfSet(selectedItem)) {
			if (selectedItem.setMemberList && selectedItem.setMemberList.length > 0) {
				tmpIsEveryMemberSubmitted = selectedItem.setMemberList.every(
					(item) => item?.planningStatus !== PLANNING_STATUS.PENDING
				);
			}
		}
		return tmpIsEveryMemberSubmitted;
	};

	useEffect(() => {
		setActiveSetMemberId(productsOfSet[0]?.id);
	}, [selectedProductId, selectedStyleDetails?.rfqId, selectedStyleDetailsFromRunning?.rfqId]);

	const onSetStyleDetails = () => {
		let selectedItem = tnaProductList?.find((item) => item.rfqId === selectedRfqId);
		setSelectedStyleDetails(selectedItem);
		setSelectedProductId(selectedItem?.id);
	};

	useEffect(() => {
		if (tnaProductList?.length > 0 && selectedRfqId) {
			onSetStyleDetails();
		}
	}, [selectedRfqId, tnaProductList]);

	const extractAndOrganizeSetMembers = (designsList = []) => {
		const membersOfSet = [];
		const compleatedTna = [];
		designsList.forEach((design) => {
			if (design.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT && design.setMemberList) {
				design.setMemberList.forEach((member) => {
					membersOfSet.push({
						...member
					});
					if (member?.planningStatus !== PLANNING_STATUS.PENDING) {
						compleatedTna.push(member?.id);
					}
				});
				membersOfSet.push({
					name: 'Finish',
					id: design?.id,
					rfqId: design?.rfqId,
					planningStatus: design?.planningStatus
				});
				if (design?.planningStatus !== PLANNING_STATUS.PENDING) {
					compleatedTna.push(design?.id);
				}
			}
		});
		setSubmittedSetMembers(compleatedTna);
		setProductsOfSet(membersOfSet);
	};

	const updateDurationForSubTask = async ({ endDate, id, notApplicable }, duration) => {
		setLoading(true);
		const reqBody = {
			deliveryDate: endDate,
			durationInDay: duration,
			id: id,
			notApplicable: notApplicable
		};

		let updateTnaDurationResponse;
		if (activeSetMemberId && !isFinishTabVisible) {
			updateTnaDurationResponse = await tnaService.updateDuration(
				orderId,
				selectedRfqId,
				reqBody,
				activeSetMemberId
			);
		} else {
			updateTnaDurationResponse = await tnaService.updateDuration(orderId, selectedRfqId, reqBody);
		}

		//setSelectedRfqId(rfqId);
		setSelectedStyle(updateTnaDurationResponse);
		setSeletecdCellForDuration('');
		const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);
		setTnaProductList(tnaProductListResponse);
		setLoading(false);
	};

	const updatingNotApplicable = async (body) => {
		setLoading(true);
		let updatedDurationResponse;
		if (activeSetMemberId && !isFinishTabVisible) {
			updatedDurationResponse = await tnaService.updateNotApplicable(
				orderId,
				selectedRfqId,
				body,
				activeSetMemberId
			);
		} else {
			updatedDurationResponse = await tnaService.updateNotApplicable(orderId, selectedRfqId, body);
		}

		setSelectedStyle(updatedDurationResponse);
		const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);
		setTnaProductList(tnaProductListResponse);
		setLoading(false);
	};

	const updateTask = async ({ taskName, deliverableName, stepName, duration }) => {
		setLoading(true);
		const reqBody = {
			dependentTaskId: stepName,
			durationInDay: duration,
			name: taskName,
			deliverableId: deliverableName
		};
		try {
			let updateTnaTaskResponse;
			if (activeSetMemberId) {
				updateTnaTaskResponse = await tnaService.updateTask(
					orderId,
					selectedRfqId,
					reqBody,
					activeSetMemberId
				);
			} else {
				updateTnaTaskResponse = await tnaService.updateTask(orderId, selectedRfqId, reqBody);
			}

			const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);
			setTnaProductList(tnaProductListResponse);
			setTaskFormInputData(INITIAL_TASK_MODAL_STATE);
			setSelectedStyle({
				...selectedStyle,
				taskPlanningResponseList: updateTnaTaskResponse?.taskPlanningResponseList
			});
			setLoading(false);
		} catch {
			setLoading(false);
		}
	};

	const getPendingProductList = (productList = []) => {
		const pendingProductList = productList.filter((item) => isPlaningPending(item));
		return pendingProductList;
	};

	const createTna = async (requiredCallback = true) => {
		let queryParams = `?planningSource=${
			selectedTemplateDays ? TNA_REQUEST_TYPE.TEMPLATE : TNA_REQUEST_TYPE.EXCEL_FILE
		}`;

		if (productsOfSet.length > 0) {
			queryParams += `&setMemberIds=${productsOfSet
				.slice(0, 2)
				.map((item) => item.id)
				.join(',')}`;
		}

		await tnaService.submitIndividualTna(
			orderId,
			requestFrom === 'TNA_RUNNING' ? rfqId : selectedRfqId,
			queryParams
		);
		if (callback && requiredCallback) {
			callback(rfqId);
		}
	};

	const updatedTnaSubmit = async () => {
		try {
			setLoading(true);
			let submitTnaResponse = await tnaService.submitTna(
				orderId,
				selectedRfqId,
				activeSetMemberId && !isFinishTabVisible ? activeSetMemberId : null
			);

			if (setProductList && requestFrom === 'TNA_RUNNING') {
				if (productsOfSet.length > 0) {
					let modifiedRunningProductList = runningProductList?.map((item) => {
						if (item.rfqId === selectedRfqId) {
							return {
								...item,
								setMemberList: item?.setMemberList?.map((member) => {
									if (member.id === activeSetMemberId) {
										return {
											...member,
											planningStatus: submitTnaResponse?.status || member.planningStatus
										};
									}
									return member;
								})
							};
						}
						return item;
					});
					setProductList(modifiedRunningProductList);
				}
			}

			setSubmittedSetMembers([...submittedSetMembers, activeSetMemberId]);
			if (submitTnaResponse) {
				const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);

				if (
					requestFrom === 'TNA_RUNNING' &&
					((productsOfSet.length > 0 && isFinishTabVisible) || productsOfSet.length === 0)
				) {
					await createTna();
				}

				setTnaProductList(tnaProductListResponse);

				const activeSet = tnaProductListResponse?.find((item) => item.rfqId === selectedRfqId);

				if (isTnaHasSetProduct && isPlaningPending(activeSet)) {
					setLoading(false);
					return;
				}

				const pendingProductList = getPendingProductList(tnaProductListResponse);

				if (pendingProductList.length > 0) {
					const firstPendingProductRfqId = pendingProductList[0].rfqId;
					if (!isProductOfSet(pendingProductList[0])) {
						getSelectedTna(
							firstPendingProductRfqId,
							'',
							'',
							pendingProductList[0]?.planningSource
						);
					} else if (isProductOfSet(pendingProductList[0])) {
						getSelectedTna(
							firstPendingProductRfqId,
							'',
							pendingProductList[0]?.setMemberList[0]?.id,
							pendingProductList[0]?.planningSource
						);
					} else if (isFinishTabVisible) {
						getSelectedTna(
							firstPendingProductRfqId,
							'',
							'',
							pendingProductList[0]?.planningSource
						);
					}
					window.scrollTo(0, 0);
				}
			}
		} catch (error) {
			printApiError(error);
		} finally {
			setLoading(false);
		}
	};

	const onSelectProduct = (product, rfqIdFromRunningTna, templateDays) => {
		setSelectedProduct(product);
		setLoading(true);
		setRfqStatusInfoList(product?.rfqStatusInfoList);
		if (rfqIdFromRunningTna && isProductOfSet(product)) {
			getSelectedTna(rfqIdFromRunningTna, '', product?.setMemberList[0]?.id, product?.planningSource);
			return;
		} else if (rfqIdFromRunningTna && !isProductOfSet(product)) {
			getSelectedTna(rfqIdFromRunningTna, '', '', product?.planningSource);
			return;
		}
		if (isProductOfSet(product)) {
			getSelectedTna(product?.rfqId, '', product?.setMemberList[0]?.id, product?.planningSource);
		} else {
			getSelectedTna(product?.rfqId, templateDays, '', product?.planningSource);
		}
	};

	const onSelectStyleForDuplication = async (rfqId, plannedProductId) => {
		setLoading(true);
		const tnaResponse = await tnaService.duplicateTask(
			orderId,
			selectedRfqId,
			rfqId,
			activeSetMemberId ? activeSetMemberId : selectedProductId,
			plannedProductId,
			requestFrom === 'TNA_RUNNING' ? selectedStyleDetailsFromRunning?.id : ''
		);

		setSelectedRfqId(tnaResponse?.rfqId);
		setSelectedStyle(tnaResponse);

		if (requestFrom === 'TNA_RUNNING') {
			await getProductList();
			await getAllProductList(false);
		} else {
			await getAllProductList();
		}
		setLoading(false);
	};

	const onTemplateDayChange = async (day) => {
		setSelectedTemplateDays(day);
		if (activeSetMemberId) {
			getSelectedTna(selectedRfqId, day?.templateName, activeSetMemberId, TNA_REQUEST_TYPE.TEMPLATE);
		} else {
			getSelectedTna(selectedRfqId, day?.templateName, '', TNA_REQUEST_TYPE.TEMPLATE);
		}

		const tnaProductListResponse = await tnaService.getAllTnaProductList(orderId);
		setTnaProductList(tnaProductListResponse);
	};

	const onChangeDuration = (e) => {
		const { value } = e.target;
		setChangedDuration(value);
	};

	const updateDuration = (e) => {
		e.preventDefault();

		const { name, value } = e.target;
		const subtask = selectedStyle?.taskPlanningResponseList.filter((el) => el.id == name)[0];
		updateDurationForSubTask(subtask, value);
	};

	const onTaskCheckboxChange = (input) => {
		const { value } = input.target;
		const taskList = chain(selectedStyle?.taskPlanningResponseList)
			.groupBy(GROUP_BY_TASK_LIST)
			.map((value, key) => ({
				[GROUP_BY_TASK_LIST]: key,
				[SUB_TASK_LABEL]: value
			}))
			.value();

		setStageTaskList(taskList);
		let body = {
			deliveryDate: '',
			durationInDay: '',
			id: '',
			notApplicable: ''
		};

		taskList.forEach((stage) => {
			stage.subTask.forEach((task) => {
				if (task.id == value) {
					task.notApplicable = !task.notApplicable;
					body.id = task.id;
					body.deliveryDate = task.endDate;
					body.durationInDay = task.durationDays;
					body.notApplicable = task.notApplicable;
				}
			});
		});

		setStageTaskList(taskList);
		updatingNotApplicable(body);
	};

	const onTaskModalOpen = () => {
		const taskList = chain(selectedStyle?.taskPlanningResponseList)
			.groupBy(GROUP_BY_TASK_LIST)
			.map((value, key) => ({
				[GROUP_BY_TASK_LIST]: key,
				[SUB_TASK_LABEL]: value
			}))
			.value();

		setStageTaskList(taskList);
		// set modal form
		taskFormInputData.deliverableName = taskList[0].deliverableId;
		taskFormInputData.stepName = taskList[0].subTask[0].id;
		taskFormInputData.startDate = moment(taskList[0].subTask[0].startDate).format('D MMM');
		taskFormInputData.startDateOrg = moment(taskList[0].subTask[0].startDate);
		setTaskFormInputData({ ...taskFormInputData });

		setShowModal(true);
	};

	const validateProperty = ({ name, value }) => {
		if (CREATE_TASK_MODAL_REQUIRED_FIELDS[name].required && !value) {
			return `${CREATE_TASK_MODAL_REQUIRED_FIELDS[name].label} is required`;
		}
		return null;
	};

	const handleAddTaskFormChange = (e) => {
		const { name, value } = e.target;
		const errorList = { ...errors };
		const errorMessage = validateProperty({ name, value });
		if (errorMessage) errorList[name] = errorMessage;
		else delete errorList[name];

		let selectedTaskOption;
		if (name === 'stepName' && value) {
			stageTaskList.forEach((stage) => {
				stage.subTask.forEach((task) => {
					if (task.id == value) {
						selectedTaskOption = task;
					}
				});
			});
			taskFormInputData.startDate = moment(selectedTaskOption?.endDate).add(1, 'days').format('D MMM');
			taskFormInputData.startDateOrg = moment(selectedTaskOption?.endDate).add(1, 'days');
			if (selectedTaskOption && taskFormInputData.duration)
				taskFormInputData.endDate = moment(taskFormInputData.startDateOrg)
					.add(taskFormInputData.duration, 'days')
					.format('D MMM');
		}

		if (name === 'duration' && value && taskFormInputData?.startDateOrg)
			taskFormInputData.endDate = moment(taskFormInputData.startDateOrg)
				.add(value, 'days')
				.format('D MMM');

		setTaskFormInputData({ ...taskFormInputData, [name]: value });
		setErrors(errorList);
	};

	const validate = (data) => {
		const errors = {};

		for (const field in CREATE_TASK_MODAL_REQUIRED_FIELDS) {
			if (CREATE_TASK_MODAL_REQUIRED_FIELDS[field].required && !data[field]) {
				errors[field] = `${CREATE_TASK_MODAL_REQUIRED_FIELDS[field].label} is required`;
			}
		}

		return Object.keys(errors).length === 0 ? null : errors;
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const errors = validate(taskFormInputData);
		setErrors(errors);
		if (errors) return;

		updateTask(taskFormInputData);
		setShowModal(false);
	};

	const onModalCancel = () => {
		setShowModal(false);
		setTaskFormInputData(INITIAL_TASK_MODAL_STATE);
		setErrors({});
	};

	const onChangeTabOfSetMember = (member, index) => {
		if (member?.name === 'Finish') {
			if (!isEveryProductOfSetSubmitted()) {
				return;
			}
		}
		if (activeSetMemberId !== member.id) {
			if (productsOfSet.length - 1 === index) {
				getSelectedTna(
					member?.rfqId,
					selectedTemplateDays?.templateName ? selectedTemplateDays?.templateName : '',
					'',
					selectedTemplateDays?.templateName
						? TNA_REQUEST_TYPE.TEMPLATE
						: TNA_REQUEST_TYPE.EXCEL_FILE
				);
				if (requestFrom === 'TNA_RUNNING' && member.planningStatus === PLANNING_STATUS.COMPLETED) {
					getProductList();
				}
			} else {
				getSelectedTna(
					member?.rfqId,
					selectedTemplateDays?.templateName ? selectedTemplateDays?.templateName : '',
					member?.id,
					selectedTemplateDays?.templateName
						? TNA_REQUEST_TYPE.TEMPLATE
						: TNA_REQUEST_TYPE.EXCEL_FILE
				);
			}
			setLoading(true);
			setActiveSetMemberId(member?.id);
		}
	};
	const onSelectFinishTab = () => {
		if (productsOfSet.length > 0) {
			const getFinshTab = productsOfSet.find((item) => item.id === activeSetMemberId);
			if (getFinshTab && getFinshTab.name === 'Finish') {
				setIsFinishTabVisible(true);
			} else {
				setIsFinishTabVisible(false);
			}
		}
	};

	useEffect(() => {
		onSelectFinishTab();
	}, [activeSetMemberId]);

	const renderDurationInput = (subTask) => {
		setSeletecdCellForDuration(subTask?.id);
		setChangedDuration(subTask?.durationDays);
	};

	const getClassNameForRow = (task) => {
		if (task?.notApplicable) {
			return '';
		} else {
			if (
				task.startDate < selectedStyleDetails?.factoryHandOverDate ||
				task.endDate > selectedStyleDetails?.factoryDeliveryDate
			)
				return 'red';
		}
		return '';
	};

	const handleExcelFileUpload = async (e) => {
		const fileInput = e.target;
		try {
			setLoading(true);
			const files = Array.from(fileInput.files);
			const { data } = await tnaService.uploadTnaExcelFile(files, orderId);
			if (data?.success) {
				toastSuccess('File uploaded successfully!');
				window.scrollTo(0, 0);
				if (requestFrom === 'TNA_RUNNING') {
					await createTna();
					getProductList();
					handleTnaSelection(selectedStyleDetailsFromRunning);
				} else {
					getAllProductList();
				}
			}
		} catch {
			fileInput.value = '';
		} finally {
			fileInput.value = '';
			setLoading(false);
		}
	};

	const handleClear = () => {
		if (requestFrom === 'TNA_RUNNING') {
			onSelectProduct(
				{ ...selectedStyleDetailsFromRunning, planningSource: TNA_REQUEST_TYPE.EXCEL_FILE },
				rfqId
			);
			setIsUsingExcel(true);
			getProductList();
		} else {
			handleTnaSelection(selectedStyleDetails, TNA_REQUEST_TYPE.EXCEL_FILE);
			getAllProductList(false);
		}
	};

	const handleStartOrder = async () => {
		try {
			setLoading(true);
			await tnaService.onStartOrder(orderId);
			navigate('/orders/my-orders?active=RUNNING');
		} catch (error) {
			printApiError(error);
		} finally {
			setLoading(false);
		}
	};

	// const handleDownloadFile = async () => {
	// 	setLoading(true);
	// 	//get rfqId from rfqStatusInfoList
	// 	const rfqIds = rfqStatusInfoList.map((item) => item.rfqId);
	// 	await tnaService
	// 		.downloadTnaExcelFile(orderId, requestFrom === 'TNA_RUNNING' ? rfqIds : selectedRfqId)
	// 		.finally(() => setLoading(false));
	// };
	const handleDownloadFile = async () => {
		setLoading(true);

		await tnaService.downloadTnaExcelFile(orderId, selectedRfqId).finally(() => setLoading(false));
	};

	const getStageWiseDependecy = (stepDescription) => {
		let selectedItem = serialList?.find((item) => item.stepDescription === stepDescription);
		return selectedItem?.serial;
	};

	const isApplicable = (subTask) => {
		// when status === COMPLEATED and using EXCEL_FILE
		if (
			selectedStyle.planningSource === TNA_REQUEST_TYPE.EXCEL_FILE &&
			!subTask.notApplicable &&
			isCompleated
		) {
			return true;
			// when using TEMPLATE
		} else if (selectedStyle.planningSource === TNA_REQUEST_TYPE.TEMPLATE) {
			return true;
		} else return false;
	};
	const renderDeliverableName = (constants = [], type = '') => {
		let taskList;
		let sl = 0;
		if (selectedStyle?.taskPlanningResponseList) {
			const filteredTasks = constants.length
				? selectedStyle?.taskPlanningResponseList.filter((task) =>
						constants.includes(task.stageConstants)
					)
				: selectedStyle?.taskPlanningResponseList.filter(
						(task) =>
							!['ORDER_PLACED', 'MATERIALS', 'SAMPLING', 'PP_ACTIVITIES'].includes(
								task.stageConstants
							)
					);
			taskList = chain(filteredTasks)
				.groupBy(GROUP_BY_TASK_LIST)
				.map((value, key) => ({
					[GROUP_BY_TASK_LIST]: key,
					[SUB_TASK_LABEL]: value
				}))
				.value();
		}

		return (
			taskList &&
			taskList.map((task) => {
				return task.subTask.map((subTask, index) => {
					sl = sl + 1;
					let className = getClassNameForRow(subTask);
					return (
						<tr key={subTask?.id}>
							<td className="deliverable-td" hidden={index != 0} rowSpan={subTask?.stepCount}>
								{subTask?.deliverableName}{' '}
							</td>
							<td>{sl}</td>
							<td className="task-td">
								<div className="custom-chekbox d-inline-block align-middle">
									<div className="form-group m-0">
										<input
											type="checkbox"
											id={subTask?.id}
											onChange={onTaskCheckboxChange}
											value={subTask?.id}
											checked={!subTask?.notApplicable}
											disabled={
												isUsingExcel ||
												isExcelFileSubmitted() ||
												(!selectedProduct?.isBaseRfq && type === 'PRE_PRODUCTION')
											}
										/>
										<label htmlFor={subTask?.id}>
											{' '}
											<span className="regular-14">{subTask?.stepName}</span>
										</label>
									</div>
								</div>
							</td>
							<td className={className}>
								{isApplicable(subTask) && moment(subTask?.endDate).format('D MMM')}
							</td>
							<td
								id={subTask?.id}
								onClick={() =>
									isUsingExcel ||
									isExcelFileSubmitted() ||
									tnaRunningStyleStatus?.planningStatus === 'SUBMITTED'
										? null
										: renderDurationInput(subTask)
								}
							>
								{isApplicable(subTask) &&
									seletecdCellForDuration !== subTask?.id &&
									subTask?.durationDays}
								{(!isUsingExcel || !isExcelFileSubmitted()) &&
									seletecdCellForDuration == subTask?.id && (
										<input
											type="number"
											id={subTask?.id}
											name={subTask?.id}
											min={0}
											autoFocus
											value={changedDuration}
											onChange={onChangeDuration}
											onKeyPress={(e) => validateNumber(e)}
											onBlur={updateDuration}
											disabled={
												!selectedProduct?.isBaseRfq && type === 'PRE_PRODUCTION'
											}
										/>
									)}
							</td>
							<td>
								{isApplicable(subTask) &&
									subTask?.dependencyList &&
									subTask?.dependencyList.map((el) => {
										return (
											<p className="p-1" key={generateRandomString()}>
												{getStageWiseDependecy(el)
													? getStageWiseDependecy(el) + '.'
													: ''}{' '}
												{el}
											</p>
										);
									})}
							</td>
						</tr>
					);
				});
			})
		);
	};

	const renderClearButton = () => {
		const clearButton = () => {
			return (
				<button className="button gray-outline size32 ml-2" onClick={handleClear}>
					<span>Clear</span>
				</button>
			);
		};
		if (isSetProduct(selectedStyleDetails)) {
			if (
				!isExcelFileSubmitted() &&
				selectedTemplateDays &&
				productsOfSet[0]?.planningStatus === PLANNING_STATUS.PENDING &&
				activeSetMemberId === productsOfSet[0]?.id
			) {
				return clearButton();
			} else return null;
		} else {
			if (
				!isExcelFileSubmitted() &&
				selectedTemplateDays &&
				selectedStyleDetails?.planningStatus === PLANNING_STATUS.PENDING
			) {
				return clearButton();
			}
		}
	};
	useEffect(() => {
		if (rfqStatusInfoList?.length > 0) {
			const baseRfq = rfqStatusInfoList?.find((rfq) => rfq.isBaseRfq);
			if (baseRfq) {
				setSelectedETD(baseRfq.rfqId);
			}
		}
	}, [rfqStatusInfoList]);

	return (
		<LoaderComponent loading={loading}>
			<div className="tna-container bg-gray">
				{isShowProducts && (
					<div className="tna-tab-container scroll-x-label p-0 mt-2">
						<TnaStylesList
							tnaProductList={tnaProductList}
							selectedStyle={selectedStyle}
							onSelectProduct={onSelectProduct}
							setSelectedStyle={setSelectedStyle}
							setIsSelectedButtonClicked={setIsSelectedButtonClicked}
							orderId={orderId}
							setLoading={setLoading}
							handleExcelFileUpload={handleExcelFileUpload}
							onStartOrder={handleStartOrder}
							getPendingProductList={getPendingProductList}
							listOfAllTnaProduct={listOfAllTnaProduct}
							setListOfAllTnaProduct={setListOfAllTnaProduct}
							rfqStatusInfoList={rfqStatusInfoList}
							selectedETD={selectedETD}
						/>
					</div>
				)}

				{!isSelecteButtonClicked && (
					<div className="tna-task-container">
						<div className="create-tna-tasks mb-20 pb-0">
							<div className="tab-and-date mb-3 d-flex justify-content-between align-items-center">
								<div className="inner-tabs pl-12 pt-12">
									{isTnaHasSetProduct && (
										<SetProductsTabButtons
											activeSetMemberId={activeSetMemberId}
											onChangeTabOfSetMember={onChangeTabOfSetMember}
											productsOfSet={productsOfSet}
											submittedSetMembers={submittedSetMembers}
											isCompleated={isCompleated}
										/>
									)}
								</div>
								<EtdDetails
									selectedStyle={selectedStyle}
									selectedStyleDetails={selectedStyleDetails}
								/>
							</div>
							{selectedStyle && (
								<div>
									<div className="d-flex justify-content-between align-items-center">
										<div className="added-task">
											<div className="d-flex align-items-center">
												<CreateDuplicateTNA
													activeSetMemberId={activeSetMemberId}
													isTnaHasSetProduct={isTnaHasSetProduct}
													loading={loading}
													onSelectStyleForDuplication={onSelectStyleForDuplication}
													onTemplateDayChange={onTemplateDayChange}
													productsOfSet={productsOfSet}
													selectedTemplateDays={selectedTemplateDays}
													tnaProductList={
														requestFrom === 'TNA_RUNNING'
															? runningProductList
															: tnaProductList
													}
													tnaTemplateDays={tnaTemplateDays}
													isTemplateDaySelected={isUsingExcel}
													isExcelFileSubmitted={isExcelFileSubmitted}
												/>
												<button
													className="button gray-outline size36"
													onClick={onTaskModalOpen}
													disabled={isUsingExcel}
												>
													<img
														src={`${process.env.PUBLIC_URL}/icons/add-round-white24.svg`}
														alt=""
													/>
													<span>Task</span>
												</button>
												{renderClearButton()}

												<AddNewTaskModal
													errors={errors}
													handleAddTaskFormChange={handleAddTaskFormChange}
													loading={loading}
													onModalCancel={onModalCancel}
													onSubmit={onSubmit}
													showModal={showModal}
													stageTaskList={stageTaskList}
													taskFormInputData={taskFormInputData}
												/>
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						<div className="common-accordion">
							<div className="accordion" id="accordionExample">
								<TNAAccordian
									id="One"
									title="Pre Production"
									expand={selectedProduct?.isBaseRfq}
								>
									{selectedStyle && (
										<div className="tna-task-table">
											<table className="table with-border">
												<thead>
													<tr>
														<th>Deliverable</th>
														<th>SL</th>
														<th>Activity</th>
														<th>Due date</th>
														<th>Duration</th>
														<th>Dependency</th>
													</tr>
												</thead>
												<tbody>
													{selectedStyle &&
														renderDeliverableName(
															[
																'ORDER_PLACED',
																'MATERIALS',
																'SAMPLING',
																'PP_ACTIVITIES'
															],
															'PRE_PRODUCTION'
														)}
												</tbody>
											</table>
										</div>
									)}
								</TNAAccordian>
								<TNAAccordian id="Two" title="Production" expand={true}>
									{selectedStyle && (
										<div className="tna-task-table">
											<table className="table with-border">
												<thead>
													<tr>
														<th>Deliverable</th>
														<th>SL</th>
														<th>Activity</th>
														<th>Due date</th>
														<th>Duration</th>
														<th>Dependency</th>
													</tr>
												</thead>
												<tbody>
													{selectedStyle && renderDeliverableName([], 'PRODUCTION')}
												</tbody>
											</table>
										</div>
									)}
								</TNAAccordian>
							</div>
						</div>
					</div>
				)}
				{selectedStyle && (
					<div className="py-3 d-flex justify-content-end">
						{isUsingExcel && (
							<>
								<div className="inline-upload mr-3 cursor-pointer">
									<label htmlFor="tna-file-upload" className="cursor-pointer">
										Upload
									</label>
									<input
										id="tna-file-upload"
										type="file"
										accept=".xlsx, .xls"
										className="file-upload d-none"
										onChange={(e) => handleExcelFileUpload(e)}
									/>
								</div>

								<button className="button size36 outline mr-3" onClick={handleDownloadFile}>
									Download
								</button>
							</>
						)}
						{!isUsingExcel && (
							<button className="button size36" onClick={updatedTnaSubmit}>
								Submit
							</button>
						)}{' '}
						{/*{requestFrom === 'TNA_RUNNING' &&*/}
						{/*	!selectedTemplateDays &&*/}
						{/*	selectedStyleDetailsFromRunning?.planningStatus === PLANNING_STATUS.SUBMITTED && (*/}
						{/*		<button className="button size36" onClick={createTna}>*/}
						{/*			Create TNA*/}
						{/*		</button>*/}
						{/*	)}*/}
					</div>
				)}
			</div>
		</LoaderComponent>
	);
};

export default CreateTna;
